import styled from 'styled-components';

import { Stack } from '@components/stack';
import { pxToRem } from '@utils/converters';

export const TableNameCellContainer = styled(Stack).attrs({
  space: 0,
  align: 'center',
  orientation: 'horizontal',
})({
  position: 'relative',
  height: '100%',
  width: '100%',
  '> :first-child': {
    flexGrow: 1,
  },
  '> :not(:first-child)': {
    position: 'relative',
    flexShrink: 0,
    width: 0,
    transition: 'none !important',
  },
  '&:hover, :has([data-active="true"])': {
    '> :first-child': {
      marginRight: pxToRem(8),
    },
    '> :not(:first-child)': {
      width: pxToRem(32),
      position: 'static',
    },
  },
});
